<template>
  <div class="usage-content">
    <div class="usage-content__thumbnail">
      <img
        :src="`/theme/rbFront/img/w/magnit/contents/${content.imageUrl}`"
        alt=""
      />
    </div>
    <div class="usage-content__label">
      {{ content.label }}
    </div>
    <div class="usage-content__bodycopy">
      {{ content.bodycopy }}
    </div>
    <div v-if="content.recommended.length" class="usage-content__recommended">
      <button type="button" @click="handleClickRecommended">
        Recommended Products
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UsageContent',
  props: {
    content: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    handleClickRecommended() {
      this.$emit('click', this.content.recommended)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.usage-content {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  &__thumbnail {
    font-size: 0;
    img {
      max-width: 100%;
    }
  }
  &__label {
    font-weight: 400;
    font-size: 32px;
    color: #000;
    text-align: center;
    margin-top: 50px;
  }
  &__bodycopy {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    color: #000;
    text-align: center;
    margin-top: 30px;
  }
  &__recommended {
    text-align: center;
    margin-top: 54px;
    button {
      font-size: 24px;
      color: #fd312e;
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 1080px) {
    margin-top: calcQuarter(80);
    &__label {
      font-size: calcQuarter(64);
      margin-top: calcQuarter(80);
      font-weight: 600;
    }
    &__bodycopy {
      font-size: calcQuarter(59);
      line-height: calcQuarter(70);
      margin-top: calcQuarter(64);
    }
    &__recommended {
      margin-top: calcQuarter(80);
      button {
        font-size: calcQuarter(59);
      }
    }
  }
}
</style>
